export function decryptJWT (token: string) {
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  const [header, payload] = token.split('.').slice(0, 2)
  return JSON.parse(atob(token.split('.')[1]))
}
